import { Injectable } from '@angular/core';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {
  loadUsers,
  LoadUserStrategy,
  selectLoadedUsersFactory,
  UserEntity,
} from '@epicuro-next/state/user-entities';
import { isNonNullish, unique } from '@epicuro-next/utilities';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class ListUsersService {
  constructor(private store: Store) {}

  public loadAndWaitForUserEntities<T>(
    resp: T,
    userIds: (string | undefined)[] | undefined,
  ) {
    const ids = (userIds ?? []).filter(isNonNullish).filter(unique);
    if (!ids || ids.length === 0) {
      return of({ resp, userEntities: [] as UserEntity[] });
    }

    this.fetchUsers(ids);

    return this.store.pipe(
      select(selectLoadedUsersFactory(ids)),
      filter(isNonNullish),
      map((userEntities) => ({
        userEntities: userEntities.filter(isNonNullish),
        resp,
      })),
    );
  }

  private fetchUsers(ids: string[]) {
    this.store.dispatch(
      loadUsers({ ids: ids.filter(unique), strategy: LoadUserStrategy.Eager }),
    );
  }
}
